import React from 'react';
// If Tippy.js is available, use it. Otherwise, fallback to native title/aria-label.
// import Tippy from '@tippyjs/react';
// import 'tippy.js/dist/tippy.css';

const TooltipWrapper = ({ children, content, placement = 'top' }) => {
  // Uncomment below if Tippy.js is installed
  // return (
  //   <Tippy content={content} placement={placement} delay={[0, 0]}>
  //     <span tabIndex={0} aria-label={content}>{children}</span>
  //   </Tippy>
  // );
  // Fallback:
  return (
    <span tabIndex={0} aria-label={content} title={content} style={{ cursor: 'help', outline: 'none' }}>
      {children}
    </span>
  );
};

export default TooltipWrapper; 